/**
 * useQuickStats — Web-specific wrapper around shared useQuickStatsCore
 *
 * Delegates to the shared core hook, passing web's authFetch and apiUrl.
 */

import { useAuth } from '@contexts/AuthContext';
import { useQuickStatsCore } from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { apiUrl } from '../config/api';

// Re-export types from the shared core, aliased for existing web consumers
export type {
  QuickPlayerStatsData as PlayerStatsData,
  QuickStatsPlayerResult as PlayerSearchResult,
  QuickStatsSearchResult as SearchResult,
  QuickStatsTeamResult as TeamSearchResult,
  QuickTeamH2HData as TeamH2HData,
  QuickTeamStatsData as TeamStatsData,
} from '@parlay-picker/shared/hooks';

export function useQuickStats() {
  const { authFetch } = useAuth();

  return useQuickStatsCore({
    fetchFn: useMemo(() => (url: string) => authFetch(url), [authFetch]),
    buildUrl: apiUrl,
  });
}
